<template>
    <div class="card shadow" style="z-index: 10">
        <div class="card-body">
            <div class="row me-5">
                <div class="col-1" style="min-width: 100px">
                    <WizardSteps :step="step" :steps="8" />
                </div>
                <div class="col-11">
                    <div class="row">
                        <div v-if="step == 1" class="col-12 infotext">
                            <h3>Step 1</h3>
                            <h2>
                                Hallo und willkommen in der
                                Projektkonfiguration.
                            </h2>
                            <p>
                                Damit nicht's schief läuft, unterstützen wir
                                Dich bei der Parameterauswahl. Da im Nachhinein
                                keine Veränderungen mehr möglich sind, solltest
                                Du unbedingt sorgfältig wählen.
                            </p>
                            <p>
                                Es gibt zwei Projekttypen, die einen zur
                                Erfassung von Anwesenheiten wie z. B.
                                Arbeitsaufwände und die anderen zu Erfassung von
                                Abwesenheiten wie z. B. Urlaube und Krankheiten.
                            </p>
                            <p>Wähle bitte den gewünschten Projekttyp.</p>
                        </div>

                        <div v-if="step == 2" class="col-12 infotext">
                            <h3>Step 2</h3>
                            <h2>
                                Mit der Kundenauswahl schaffst Du den Bezug zum
                                Auftraggeber.
                            </h2>
                            <p>
                                Kunden sind frei anlegbar (<a href="/clients" target="_new">Link</a>). Du kannst
                                Tätigkeiten
                                im Auftrag eines
                                Kunden oder im Auftrag der eigenen Organisation
                                erfassen.
                            </p>
                            <p>Wähle bitte einen Kunden </p>
                        </div>

                        <div v-if="step == 3 && presence == true" class="col-12 infotext">
                            <h3>Step 3</h3>
                            <h2>
                                Um deine Projekte zu strukturieren, kannst du
                                Projekttypen definieren.
                            </h2>
                            <p>
                                Wähle bitte den passenden Projekttyp aus der
                                Liste oder lege bei Bedarf einen neuen an (<a href="/projecttypes"
                                    target="_new">Link</a>).
                                Sollten deine Rechte hierzu nicht
                                ausreichen, wende Dich bitte an den
                                Systemadministrator.
                            </p>
                        </div>

                        <div v-if="step == 3 && absence == true" class="col-12 infotext">
                            <h3>Step 3</h3>
                            <h2>Art der Abwesenheit festlegen.</h2>
                            <p>
                                Welche Art von Abwesenheit soll erfasst werden?
                                Krankheit, Urlaub oder ungeklährtes Fehlen
                                können einem eigenen Projekt zugeordnet werden
                                um den Überblick zu behalten.
                            </p>
                        </div>

                        <div v-if="step == 4" class="col-12 infotext">
                            <h3>Step 4</h3>
                            <h2>
                                Die Projektbezeichnung besteht aus dem
                                Projekttyp und der Bezeichnung.
                            </h2>
                            <p>
                                Wähle eine aussagekräftige Bezeichnung mit
                                maximal 20 Zeichen. 
                            </p>
                        </div>

                        <div v-if="step == 5" class="col-12 infotext">
                            <h3>Step 5</h3>
                            <h2>
                                Definiere nun bitte, ob dein Projekt separat
                                abgerechnet werden soll.
                            </h2>
                            <p>
                                Entscheidest Du dich für eine separate
                                Abrechnung, werden die erfassten Stunden unter
                                dem Menu-Punkt "Sonderleistungen" angezeigt und
                                gesammelt. Dort behältst Du alle Leistungen im
                                Blick und kannst sie per Knopfdruck abrechnen.
                                Definiere bitte auch eine Abrechnungseinheit
                                (Stunden, Stück oder Pauschale).
                            </p>
                            <p>
                                Entscheidest Du dich gegen eine separate
                                Abrechnung, werden die geleisteten Stunden nur
                                in den Reports angezeigt.
                            </p>
                        </div>

                        <div v-if="step == 6" class="col-12 infotext">
                            <h3>Step 6</h3>
                            <h2>Gib Deinem Projekt eine Farbe.</h2>
                            <p>
                                Dein Projekt braucht noch eine Farbe damit Du es
                                in den diversen Menus und Ansichten leicht
                                identifizieren kannst.
                            </p>
                        </div>

                        <div v-if="step == 7" class="col-12 infotext">
                            <h3>Step 6</h3>
                            <h2>Zuständiges Team.</h2>
                            <p>
                                Welches Team ist für das Projekt zuständig?
                            </p>
                        </div>

                        <div v-if="step == 8" class="col-12 infotext">
                            <h3>Step 7</h3>
                            <h2>Wie komplex ist Dein Projekt?</h2>
                            <p>
                                Welche Qualifikationen sollte der Mitarbeiter haben und
                                wie lange brauchen neue Teammitglieder um die
                                verbundenen Tätigkeiten zu meistern? Wähle einen
                                gesunden Durchschnittswert in Tagen und packe
                                lieber etwas Zeit oben drauf.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6" v-if="step == 1">
                            <button class="btn btn-primary me-2 projectkind" @click="presenceProject">
                                <i class="fa-solid fa-person-walking fa-xl"></i>&nbsp;
                                <i class="fa-solid fa-industry fa-xl mb-5"></i><br />
                                {{ $trans.get("__JSON__.Presence project") }}
                            </button>
                            <button class="btn btn-primary projectkind" @click="absenceProject">
                                <i class="fa-solid fa-user-doctor fa-xl"></i>&nbsp;
                                <i class="fa-solid fa-plane-departure fa-xl mb-5"></i><br />
                                {{ $trans.get("__JSON__.Absence project") }}
                            </button>
                        </div>
                    </div>
                    <div v-if="step >= 2">
                        <div class="row mb-2">
                            <div v-if="presence == true" class="col-6">
                                <label for="client_id" class="form-label">{{
                                    $trans.get("__JSON__.Projecttype")
                                    }}</label>
                                <input class="form-control" type="text" :value="$trans.get('__JSON__.Presence project')
                                    " disabled />
                            </div>
                            <div v-if="absence == true" class="col-6">
                                <label for="client_id" class="form-label">{{
                                    $trans.get("__JSON__.Projecttype")
                                    }}</label>
                                <input class="form-control" type="text" :value="$trans.get('__JSON__.Absence project')
                                    " disabled />
                            </div>
                        </div>
                    </div>

                    <div v-if="step >= 2" class="row mb-2">
                        <div class="col-6">
                            <div v-if="errors['client_id']">
                                <span v-for="error in errors['client_id']" class="text-danger">
                                    {{ error }}
                                </span>
                            </div>
                            <label for="client_id" class="form-label">{{
                                $trans.get("__JSON__.Client")
                                }}</label>
                            <select class="form-control" v-model="project.client_id" name="client_id" id="client_id"
                                :disabled="step > 2">
                                <option value="0" selected>
                                    Choose client
                                </option>
                                <option v-for="item in clients" :key="item.id" :value="item.id">
                                    {{ item.name }}
                                </option>
                            </select>
                        </div>

                        <div v-if="step > 2" class="col-6">
                            <label for="name" class="form-label">{{
                                $trans.get("__JSON__.Name")
                                }}</label>
                            <input type="text" id="name" class="form-control" v-model="project.name" readonly />
                        </div>
                    </div>

                    <div v-if="step > 2">
                        <div v-if="errors['project_type_id']">
                            <span v-for="error in errors['project_type_id']" class="text-danger">
                                {{ error }}
                            </span>
                        </div>
                        <div v-if="errors['absence_type_id']">
                            <span v-for="error in errors['absence_type_id']" class="text-danger">
                                {{ error }}
                            </span>
                        </div>
                        <div class="row mb-2">
                            <div class="col-3">
                                <label for="project_type_id" class="form-label">{{
                                    $trans.get("__JSON__.Projecttype")
                                    }}</label>
                                <select class="form-control" v-model="project.project_type_id" name="project_type_id"
                                    id="project_type_id" :disabled="step > 3 || (step == 3 && absence == 1)
                                        ">
                                    <option value="0" selected>
                                        Choose project type
                                    </option>
                                    <option v-for="item in projecttypes" :key="item.id" :value="item.id">
                                        {{ item.name }}
                                    </option>
                                </select>
                            </div>

                            <div class="col-3" v-if="absence == false">
                                <label for="costcentre" class="form-label">{{
                                    $trans.get("__JSON__.Other costcentre")
                                    }}</label>
                                <!-- <input type="text" class="form-control" v-model="project.costcentre"
                                    :disabled="step > 3"> -->
                                <select v-model="project.costcentre" class="form-control" id="costcentre"
                                    name="costcentre" :disabled="step > 3">
                                    <option value=""></option>
                                    <option v-for="costcentre in costcentres" :key="costcentre.id"
                                        :value="costcentre.costcentre">
                                        {{ costcentre.costcentre }} / {{ costcentre.name }}</option>
                                </select>
                            </div>

                            <div class="col-3">
                                <div v-if="absence == true">
                                    <label for="project_type_id" class="form-label">{{
                                        $trans.get("__JSON__.Absencetype")
                                        }}</label>
                                    <select class="form-control" v-model="project.absence_type_id"
                                        name="absence_type_id" id="absence_type_id" :disabled="step > 3">
                                        <option value="0" selected>
                                            {{ $trans.get('__JSON__.Choose absence type') }}
                                        </option>
                                        <option v-for="item in manualAbsencetypes" :key="item.id" :value="item.id">
                                            {{ $trans.get('__JSON__.' + item.name) }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div v-if="project.absence_type_id == 3" class="col-2">
                                <label for="unexcused" class="form-label">{{
                                    $trans.get("__JSON__.Unexcused")
                                    }}</label>
                                <select class="form-control" v-model="project.unexcused" name="unexcused" id="unexcused"
                                    :disabled="step > 3">
                                    <option value="0">
                                        {{ $trans.get("__JSON__.No") }}
                                    </option>
                                    <option value="1">
                                        {{ $trans.get("__JSON__.Yes") }}
                                    </option>
                                </select>
                            </div>

                            <div v-if="project.absence_type_id == 1 || project.absence_type_id == 3" class="col-2">
                                <label for="unpaid" class="form-label">{{
                                    $trans.get("__JSON__.Unpaid")
                                    }}</label>
                                <select class="form-control" v-model="project.unpaid" name="unpaid" id="unpaid"
                                    :disabled="step > 3">
                                    <option value="0">
                                        {{ $trans.get("__JSON__.No") }}
                                    </option>
                                    <option value="1">
                                        {{ $trans.get("__JSON__.Yes") }}
                                    </option>
                                </select>
                            </div>
                            <div v-if="project.absence_type_id == 1 || project.absence_type_id == 3" class="col-2">
                                <label for="proove_required" class="form-label">{{
                                    $trans.get("__JSON__.Proove required")
                                    }}</label>
                                <select class="form-control" v-model="project.proove_required" name="proove_required"
                                    id="proove_required" :disabled="step > 3">
                                    <option value="0">
                                        {{ $trans.get("__JSON__.No") }}
                                    </option>
                                    <option value="1">
                                        {{ $trans.get("__JSON__.Yes") }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div v-if="step > 3">
                        <div class="row mb-2">
                            <div class="col-6">
                                <div v-if="errors['specification']">
                                    <span v-for="error in errors['specification']" class="text-danger">
                                        {{ error }}
                                    </span>
                                </div>
                                <label for="specification" class="form-label">{{
                                    $trans.get("__JSON__.Specification")
                                    }}</label>
                                <input type="text" id="specification" class="form-control"
                                    v-model="project.specification" :disabled="step > 4" />
                            </div>

                            <div class="col-3">
                                <div v-if="absence == true">
                                    <label for="wage_type_id" class="form-label">{{
                                        $trans.get("__JSON__.Wage type")
                                        }}</label>
                                    <select class="form-control" v-model="project.wage_type_id" name="wage_type_id"
                                        id="wage_type_id" :disabled="step > 4">
                                        <option value="0">
                                            {{ $trans.get('__JSON__.Choose wage type') }}
                                        </option>
                                        <option v-for="item in wagetypes" :key="item.id" :value="item.id">
                                            {{ item.description }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div v-if="step > 4" class="row mb-2">
                        <div class="col-3">
                            <div v-if="errors['bill']">
                                <span v-for="error in errors['bill']" class="text-danger">
                                    {{ error }}
                                </span>
                            </div>
                            <label for="bill" class="form-label">{{
                                $trans.get("__JSON__.Projecttype")
                                }}</label>
                            <select class="form-control" v-model="project.bill" name="bill" id="bill"
                                :disabled="step > 5">
                                <option value="0" selected>
                                    {{ $trans.get('__JSON__.No separate billing') }}
                                </option>
                                <option value="1" selected>
                                    {{ $trans.get('__JSON__.Bill separate') }}
                                </option>
                            </select>
                        </div>
                        <div class="col-3">
                            <div v-if="project.bill == 1">
                                <label for="client_service_metric_id" class="form-label">{{
                                    $trans.get("__JSON__.Service metric")
                                    }}</label>
                                <select class="form-control" v-model="project.client_service_metric_id"
                                    name="client_service_metric_id" id="client_service_metric_id" :disabled="step > 5">
                                    <option value="0" selected>
                                        Choose service metric
                                    </option>
                                    <option v-for="item in clientservicemetrics" :key="item.id" :value="item.id">
                                        {{ item.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-3">
                            <div v-if="errors['notificable']">
                                <span v-for="error in errors['notificable']" class="text-danger">
                                    {{ error }}
                                </span>
                            </div>
                            <label for="notificable" class="form-label">{{
                                $trans.get("__JSON__.Notificable")
                                }}</label>
                            <select class="form-control" v-model="project.notificable" name="notificable"
                                id="notificable" :disabled="step > 8">
                                <option value="1">
                                    {{ $trans.get('__JSON__.Yes') }}
                                </option>
                                <option value="0">
                                    {{ $trans.get('__JSON__.No') }}</option>
                            </select>
                        </div>
                    </div>
                    <div v-if="step > 4" class="row mb-2">
                       
                    </div>

                    <div v-if="step > 5" class="row mb-2">
                        <div class="col-2">
                            <div v-if="errors['color']">
                                <span v-for="error in errors['color']" class="text-danger">
                                    {{ error }}
                                </span>
                            </div>
                            <label for="wcolor" class="form-label">{{
                                $trans.get("__JSON__.Color")
                                }}</label>
                            <input type="text" class="form-control" id="wcolor" name="wcolor" autocomplete="off"
                                v-model="project.color" :disabled="step > 6" />
                        </div>

                        <div class="col-4"></div>
                    </div>

                    <div v-if="step > 6 && presence" class="row mb-2">
                        <div class="col-6">
                            <div v-if="errors['costcentre_team_id']">
                                <span v-for="error in errors['costcentre_team_id']" class="text-danger">
                                    {{ error }}
                                </span>
                            </div>
                            <label for="costcentre_team_id" class="form-label">{{
                                $trans.get("__JSON__.Costcentre team")
                                }}</label>
                            <select class="form-control" v-model="project.costcentre_team_id" name="costcentre_team_id"
                                id="costcentre_team_id" :disabled="step > 7">
                                <option value="0" selected>
                                    Choose team
                                </option>
                                <option v-for="item in teams" :key="item.id" :value="item.id">
                                    {{ item.name }}
                                </option>
                            </select>
                        </div>
                    </div>


                    <div v-if="step > 7 && presence" class="row mb-2">
                        <div class="col-3">
                            <div v-if="errors['experience_calculation']">
                                <span v-for="error in errors['experience_calculation']" class="text-danger">
                                    {{ error }}
                                </span>
                            </div>
                            <label for="experience_calculation" class="form-label">{{
                                $trans.get("__JSON__.Calculate experience")
                                }}</label>
                            <select class="form-control" v-model="project.experience_calculation"
                                name="experience_calculation" id="experience_calculation" :disabled="step > 8">
                                <option value="0">
                                    {{ $trans.get('__JSON__.No Calculation') }}
                                </option>
                                <option value="1">
                                    {{ $trans.get('__JSON__.Calculate') }}</option>
                            </select>
                        </div>

                        <div class="col-2">
                            <label for="qualification_days" class="form-label">{{
                                $trans.get("__JSON__.Days minimal")
                                }}</label>
                            <input type="number" class="form-control" id="qualification_days"
                                v-model="project.qualification_days" v-if="project.experience_calculation == 1" />
                        </div>
                        <div class="col-4"></div>
                    </div>

                    <div v-if="step > 7 && presence" class="row mb-2">
                        <label for="project_qualifications" class="form-label">{{
                            $trans.get("__JSON__.Project quallifications")
                            }}</label>
                        <project-qualifications :existingqualifications="existingqualifications" />
                    </div>

                    <div v-if="step > 1" class="row">
                        <div class="col-6">
                            <button class="btn btn-secondary me-2" :disabled="step < 2" @click="stepBack">
                                {{ $trans.get("__JSON__.Previous") }}
                            </button>

                            <button v-if="(step < 8 && absence == false) ||
                                (step < 6 && absence == true)
                            " class="btn btn-secondary" :disabled="!nextAvailable()" @click="stepForward">
                                {{ $trans.get("__JSON__.Next") }}
                            </button>

                            <button v-if="step == 8 ||
                                (step == 6 &&
                                    absence == true &&
                                    project.color != '')
                            " class="btn btn-primary" @click="saveProject">
                                {{ $trans.get("__JSON__.Save") }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, watch } from "vue";

import getClients from "../composables/getClients";
import getTeams from "../composables/getTeams";
import getProjectTypes from "../composables/getProjectTypes";
import getClientServiceMetrics from "../composables/getClientServiceMetrics";
import getAbsenceTypes from "../composables/getAbsenceTypes";
import WizardSteps from "./WizardSteps.vue";
import WageTypes from "../composables/Wagetypes";
import getCostcentres from "../composables/getCostcentres";

export default {
    name: "Project",
    components: {
        WizardSteps,
    },
    props: {
        project_id: Number
    },
    setup(props) {
        const step = ref(1);
        const error = ref(null);
        const project = ref(null);

        const load = async () => {
            try {
                var url = "/api/projects/create";
                if (props.project_id != undefined) {
                    url = "/api/projects/" + parseInt(props.project_id);
                }
                let data = await fetch(url);

                if (!data.ok) {
                    throw Error("Can't load data");
                }

                project.value = await data.json();
                console.log(project.value);
            } catch (err) {
                error.value = err.message;
            }
        };

        load();
        project.client_id = 0;

        const { clients, clients_error, loadClients } = getClients();
        loadClients();

        const { teams, teams_error, loadTeams } = getTeams();
        loadTeams();

        const { projecttypes, projecttypes_error, loadProjectTypes } =
            getProjectTypes();
        loadProjectTypes();

        const { costcentres, costcentres_error, loadCostcentres } = getCostcentres();
        loadCostcentres();

        const {
            clientservicemetrics,
            clientservicemetrics_error,
            loadClientServiceMetrics,
        } = getClientServiceMetrics();
        loadClientServiceMetrics();

        const { absencetypes, absencetypes_error, loadAbsenceTypes } =
            getAbsenceTypes();
        loadAbsenceTypes();

        const { wagetypes, wagetypes_error, loadWagetypes, saveWagetype } = WageTypes();
        loadWagetypes();



        return {
            step,
            project,
            error,
            clients,
            projecttypes,
            clientservicemetrics,
            absencetypes,
            teams,
            wagetypes,
            costcentres
        };
    },
    data() {
        return {
            errors: [],
            absence: null,
            presence: null,
            client_name: null,
        };
    },
    updated() {
        if (this.step == 6) {
            const that = this;

            $("#wcolor").spectrum({
                preferredFormat: "hex",
                type: "component",
                change: function (color) {
                    console.log(that.project);
                    that.project.color = color.toHexString();
                },
            });
        }
    },
    watch: {
        project: {
            handler(newValue, oldValue) {
                if (oldValue == null && newValue.id) {
                    console.log('Watch project loaded!');

                    this.absence = false;
                    if (newValue.absence_type_id > 0) {
                        this.absence = true;
                    }
                    this.presence = !this.absence;

                    this.stepForward();
                    this.stepForward();
                }

                if (oldValue != null) {
                    var name = "";

                    const client = this.clients.find(
                        (item) => item.id == this.project.client_id
                    );
                    if (client) {
                        this.client_name = client.name;
                    }

                    const projecttype = this.projecttypes.find(
                        (item) => item.id == this.project.project_type_id
                    );

                    if (projecttype && !projecttype.system) {
                        name = name + " " + projecttype.shortname;
                    }

                    name = name + " " + (this.project.specification ?? '');
                    this.project.name = name.trim();
                }
            },
            deep: true,
        },
    },
    computed: {
        manualAbsencetypes() {
            if (this.absencetypes) {
                return this.absencetypes.filter((absencetype) => absencetype.not_manual == 0);
            }
            return null;
        },
        existingqualifications() {
            var qualifications = [];
            console.log('Existing Quali', this.project);
            if (this.project?.requiredqualifications) {
                this.project.requiredqualifications.forEach(
                    qualification => {
                        qualifications.push(qualification.id);
                    }
                );
            }
            return qualifications;
        }
    },
    methods: {
        nextAvailable() {
            console.log("Step", this.step);
            console.log("Project", this.project);

            if (this.step == 2 && this.project.client_id > 0) {
                return true;
            }

            if (
                this.step == 3 &&
                this.project.project_type_id > 0 &&
                this.presence == true
            ) {
                return true;
            }

            if (
                this.step == 3 &&
                this.project.absence_type_id > 0 &&
                this.absence == true
            ) {
                return true;
            }

            if (this.step == 4 && this.project.name != "") {
                return true;
            }

            if (this.step == 5) {
                if (this.project.bill == 0) {
                    return true;
                } else {
                    if (this.project.client_service_metric_id > 0) {
                        return true;
                    }
                }
            }

            if (this.step == 6 && this.project.color != "") {
                return true;
            }

            if (this.step == 7) {
                return true;
            }

            return false;
        },
        stepForward() {
            this.step++;

            if (this.step == 5 && this.absence == true) {
                this.step++;
            }
        },
        stepBack() {
            if (this.step > 1) {
                this.step--;
            }
        },
        presenceProject() {
            this.project.absence = false;
            this.project.unpaid = 0;
            this.presence = true;
            this.absence = false;
            this.project.client_id = 0;
            this.stepForward();
        },
        absenceProject() {
            this.project.absence = true;
            this.project.unpaid = 0;
            this.absence = true;
            this.presence = false;

            this.stepForward();

            const client = this.clients.find((item) => item.self == true);
            if (client) {
                this.project.client_id = client.id;
                this.stepForward();
            }

            const projecttype = this.projecttypes.find(
                (item) => item.system == true
            );
            if (projecttype) {
                this.project.project_type_id = projecttype.id;
            }
        },
        saveProject() {
            if (this.project.absence_type_id == 4) {
                this.project.utility = 1;
            }

            this.project.qualifications = [];

            const that = this;
            $('.qualificationarray').each(function (index) {
                console.log(index + " " + $(this).val());
                that.project.qualifications.push($(this).val());
            });


            if (this.project.id) {
                axios
                    .put("/api/projects/" + this.project.id, this.project)
                    .then((resp) => {
                        self.errors = [];
                        location.href = "/projects";
                    })
                    .catch((error) => {
                        this.errors = error.response.data.errors;
                        self.errors = error.response.data.errors;
                        if (self.errors.week != null) {
                            self.$emit(
                                "employeeError",
                                this.employeeshift.employee_id
                            );
                        }
                    });

            } else {
                axios
                    .post("/api/projects", this.project)
                    .then((resp) => {
                        self.errors = [];
                        location.href = "/projects";
                    })
                    .catch((error) => {
                        this.errors = error.response.data.errors;
                        self.errors = error.response.data.errors;
                        if (self.errors.week != null) {
                            self.$emit(
                                "employeeError",
                                this.employeeshift.employee_id
                            );
                        }
                    });
            }
        },
    },
};
</script>

<style scoped>
p {
    margin: 0;
}

h2 {
    font-weight: bold;
}

h3 {
    margin-top: 0.5rem;
    margin-bottom: 2rem;
}

.infotext {
    margin-bottom: 2rem;
    padding: 2rem;
}

a {
    font-weight: bold;
}

.projectkind {
    height: 14rem;
}
</style>
